// Flatten orders into grouped grid rows: one styled "header" row per order,
// followed by one "item" row per line item. The whole group shares the order's
// status (for colour-coding) and orderId (for whole-group reordering).

export function flattenOrders(orders) {
  const rows = [];
  orders.forEach((order, orderIndex) => {
    const status = order.workflow?.status || '';
    const items = order.lineItems && order.lineItems.length ? order.lineItems : [{ lineId: 'li_0' }];

    // Single line item -> one combined row. Colour by the effective header status
    // (which, for one line, reflects its production status + any manual override).
    if (items.length === 1) {
      rows.push({
        id: `${order.id}::single`,
        kind: 'single',
        orderId: order.id,
        orderIndex,
        status, // effective — for colour
        order,
        lineItem: items[0],
      });
      return;
    }

    // Multiple line items -> a header row (coloured by effective status) followed
    // by one row per item (each coloured by ITS OWN line status).
    rows.push({ id: `${order.id}::hdr`, kind: 'header', orderId: order.id, orderIndex, status, order });
    items.forEach((lineItem) => {
      rows.push({
        id: `${order.id}::${lineItem.lineId}`,
        kind: 'item',
        orderId: order.id,
        orderIndex,
        status: lineItem.status || status, // colour item row by its own status
        order,
        lineItem,
      });
    });
  });
  return rows;
}

/** A class-name-safe slug for a status string (for per-status row CSS). */
export function statusSlug(status) {
  return String(status || 'none')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '') || 'none';
}
